import { PROP_ANY, PROP_BOOLEAN, PROP_NUMBER, PROP_STRING, register } from '../../framework/widget-props';

export const registerProps = () => {
    register(
        'wm-chart',
        new Map(
            [
                ['aggregation', {value: 'none', ...PROP_STRING}],
                ['aggregationcolumn', PROP_STRING],
                ['areaviewtype', {value: 'stack', ...PROP_STRING}],
                ['barspacing', {value: 'medium', ...PROP_STRING}],
                ['bubblesize', PROP_STRING],
                ['centerlabel', PROP_STRING],
                ['customcolors', PROP_STRING],
                ['dataset', PROP_ANY],
                ['datasource', PROP_STRING],
                ['donutratio', {value: 'medium', ...PROP_STRING}],
                ['formattype', {value: '', PROP_STRING}],
                ['groupby', PROP_STRING],
                ['height', {value: '210px', PROP_STRING}],
                ['highlightpoints', PROP_BOOLEAN],
                ['iconclass', PROP_STRING],
                ['interpolation', {value: 'linear', ...PROP_STRING}],
                ['labelthreshold', {value: 0.01, ...PROP_NUMBER}],
                ['labeltype', {value: 'percent', ...PROP_STRING}],
                ['legendtype', {value: 'furious', ...PROP_STRING}],
                ['linethickness', PROP_STRING],
                ['loadingdatamsg', {value: 'Loading...', ...PROP_STRING}],
                ['name', PROP_STRING],
                ['nodatamessage', {value: 'No Data Available.', ...PROP_STRING}],
                ['offset', PROP_STRING],
                ['offsetbottom', {value: 55, ...PROP_NUMBER}],
                ['offsetleft', {value: 75, ...PROP_NUMBER}],
                ['offsetright', {value: 25, ...PROP_NUMBER}],
                ['offsettop', {value: 25, ...PROP_NUMBER}],
                ['orderby', PROP_STRING],
                ['reducexticks', {value: true, ...PROP_BOOLEAN}],
                ['shape', {value: 'circle', ...PROP_STRING}],
                ['show', {value: true, ...PROP_BOOLEAN}],
                ['showlabels', {value: 'outside', ...PROP_STRING}],
                ['showlabelsoutside', {value: true, ...PROP_BOOLEAN}],
                ['showlegend', {value: 'top', ...PROP_STRING}],
                ['showvalues', {value: false, ...PROP_BOOLEAN}],
                ['showxaxis', {value: true, ...PROP_BOOLEAN}],
                ['showxdistance', {value: false, ...PROP_BOOLEAN}],
                ['showyaxis', {value: true, ...PROP_BOOLEAN}],
                ['showydistance', {value: false, ...PROP_BOOLEAN}],
                ['staggerlabels', {value: false, ...PROP_BOOLEAN}],
                ['subheading', PROP_STRING],
                ['theme', PROP_STRING],
                ['title', PROP_STRING],
                ['tooltips', {value: true, ...PROP_BOOLEAN}],
                ['type', PROP_STRING],
                ['viewtype', {value: 'Grouped', ...PROP_STRING}],
                ['xaxisdatakey', PROP_STRING],
                ['xaxislabel', PROP_STRING],
                ['xaxislabeldistance', {value: 12, ...PROP_NUMBER}],
                ['xdateformat', PROP_STRING],
                ['xdomain', {value: 'Default', ...PROP_STRING}],
                ['xnumberformat', PROP_STRING],
                ['xunits', PROP_STRING],
                ['yaxisdatakey', PROP_STRING],
                ['yaxislabel', PROP_STRING],
                ['yaxislabeldistance', {value: 12, ...PROP_NUMBER}],
                ['ydomain', {value: 'Default', ...PROP_STRING}],
                ['ynumberformat', PROP_STRING],
                ['yunits', PROP_STRING]
            ]
        )
    );
};
